import React from 'react';
import { motion } from 'framer-motion';
import { Router, Wifi } from 'lucide-react';

/**
 * TabNavigation component
 * Displays the tab navigation for the modal
 */
const TabNavigation = ({ activeTab, setActiveTab }) => {
  // Tab animation variants
  const tabVariants = {
    inactive: { opacity: 0.7, y: 0 },
    active: { opacity: 1, y: 0, transition: { duration: 0.3 } }
  };

  return (
    <div className="flex border-b border-gray-800">
      <motion.button
        className={`flex-1 py-4 px-6 text-center font-medium text-lg ${
          activeTab === 'router' ? 'text-purple-400 border-b-2 border-purple-400' : 'text-gray-400'
        }`}
        onClick={() => setActiveTab('router')}
        variants={tabVariants}
        animate={activeTab === 'router' ? 'active' : 'inactive'}
      >
        <div className="flex items-center justify-center">
          <Router className="h-5 w-5 mr-2" />
          Router Features
        </div>
      </motion.button>
      <motion.button
        className={`flex-1 py-4 px-6 text-center font-medium text-lg ${
          activeTab === 'isp' ? 'text-purple-400 border-b-2 border-purple-400' : 'text-gray-400'
        }`}
        onClick={() => setActiveTab('isp')}
        variants={tabVariants}
        animate={activeTab === 'isp' ? 'active' : 'inactive'}
      >
        <div className="flex items-center justify-center">
          <Wifi className="h-5 w-5 mr-2" />
          ISP Service Features
        </div>
      </motion.button>
      <motion.button
        className={`flex-1 py-4 px-6 text-center font-medium text-lg ${
          activeTab === 'mesh' ? 'text-purple-400 border-b-2 border-purple-400' : 'text-gray-400'
        }`}
        onClick={() => setActiveTab('mesh')}
        variants={tabVariants}
        animate={activeTab === 'mesh' ? 'active' : 'inactive'}
      >
        <div className="flex items-center justify-center">
          <Wifi className="h-5 w-5 mr-2" />
          Mesh Technology
        </div>
      </motion.button>
    </div>
  );
};

export default TabNavigation;